

/* COOKIES */

import moment from "moment";
import { ConfigConstants } from "./config";

// used for admin auth
export const BILLSBY_ADMIN_AUTH_DATA_CONTROL = "billsby_admin_auth_data_control";

/**
 * this IFE returns the environment (dev, test, prod) key used in the auth cookie 
 * so we can login in the same browser in multiple environments e.g in dev and test without logging out from one of the others
 */
 type EnvType = "_dev" | "_test" | "";
 const environment: EnvType = (function getEnv() {
   const isRunningTests = process.env.JEST_WORKER_ID !== undefined;
   if(isRunningTests) { 
     return "_test" 
   }
 
   const isDev = ConfigConstants.baseUrl.includes("dev") ? true : false;
   const isTest = ConfigConstants.baseUrl.includes("test") ? true : false;
   return isDev ? "_dev" : isTest ? "_test" : "";
 }())
 
 /* COOKIES used for impersonation */
 export const BILLSBY_AUTH_DATA_CONTROL = `billsby_auth_data_control${environment}`;
 export const BILLSBY_SELECTED_COMPANY = `billsby_selected_company${environment}`;
 export const BILLSBY_ONE_SESSION_LOGIN = `billsby_one_session_login${environment}`;
 export const BILLSBY_PRELIVE_FIRST_TIME = `billsby_prelive_first_time${environment}`;
 

/* STORE TYPES */
export const SESSION_STORAGE = "sessionStorage";
export const LOCAL_STORAGE = "localStorage";
export const COOKIE_STORAGE = "cookieStorage";

/**
 * internal mapping from spreedly errors to user errors
 * https://docs.spreedly.com/reference/iframe/v1/#errors
 */
 export const SPREEDLY_ERRORS: { [key: string]: string } = {
  'errors.account_inactive': 'SPREEDLY_ERROR_GENERIC',
  'errors.environment_key_parameter_required': 'SPREEDLY_ERROR_GENERIC',
  'errors.invalid_environment_key_parameter': 'SPREEDLY_ERROR_GENERIC',
  'errors.blank': 'SPREEDLY_ERROR_CARD_INVALID',
  'errors.invalid': 'SPREEDLY_ERROR_CARD_INVALID',
  'errors.blank_card_type': 'SPREEDLY_ERROR_CARD_TYPE_INVALID',
  'errors.expired': 'SPREEDLY_ERROR_CARD_EXPIRED',
  'errors.unknown_referrer': 'SPREEDLY_ERROR_GENERIC',
  'errors.invalid_referrer': 'SPREEDLY_ERROR_GENERIC',
  'errors.configuration': 'SPREEDLY_ERROR_GENERIC'
};

export const SPREEDLY_TEST_CREDIT_CARD = '4111111111111111';
export const SPREEDLY_TEST_CVV = '123';
export const SPREEDLY_TEST_EXP_YEAR = moment.utc().add(3, 'years').year();
export const SPREEDLY_TEST_EXP_MONTH = 12;
export const SPREEDLY_TEST_CARD_NAME = 'Sandbox Test Card'

export const EMAIL_REGEX = /^\S+@\S+$/;

export const PAGINATION_PAGE_SIZE = 15;
